export default __webpack_public_path__ + "static/media/reports-16.f775bbb4.png";